import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Dialog } from 'primereact/dialog'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Badge,
  Btn,
  CustomDataTableHeader,
  CustomInputTextArea,
  CustomPanel,
  PageHeader,
  Periodo,
  ThreeDots,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import { errorHandler } from '../../../../services/util/error.service'
import { formatIsoDateToLocale, getPeriodoMesAtual, parseToMysqlFormatWithTime } from '../../../../services/util/date.service'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { menuItemsAllowed } from '../../../../services/permission/menus'
import {
  getReconferenciaEtiquetaList,
  postReconferenciaEtiquetaCancelar,
} from '../../../../services/api/https/picking/picking.http'

const STATUS_COLORS = {
  'Em Andamento': '#f0ad4e',
  Finalizado: '#5cb85c',
  Cancelado: '#d9534f',
}

function ReconferenciaEtiqueta({ dispatch, history, selectedTp }) {
  const { dataInicial, dataFinal } = getPeriodoMesAtual()
  const [globalFilter, setGlobalFilter] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState([])
  const [periodo, setPeriodo] = useState({ dataInicial, dataFinal })

  // Cancel modal
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [selectedConferencia, setSelectedConferencia] = useState(null)
  const [cancelReason, setCancelReason] = useState('')

  // Canceled info modal
  const [showCanceledInfoModal, setShowCanceledInfoModal] = useState(false)
  const [canceledInfo, setCanceledInfo] = useState(null)

  useEffect(() => {
    if (selectedTp) {
      buscar()
    }
  }, [selectedTp])

  const buscar = async () => {
    if (!selectedTp) return
    setIsLoading(true)
    try {
      const result = await getReconferenciaEtiquetaList(
        selectedTp,
        parseToMysqlFormatWithTime(periodo.dataInicial),
        parseToMysqlFormatWithTime(periodo.dataFinal),
      )
      setData(result)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoading(false)
    }
  }

  const canCancel = menuItemsAllowed([{ id: 135, content: {} }]).length > 0

  const getMenuItems = row => {
    const items = ['Ver Resultado']
    if (canCancel && row.status !== 'Cancelado') {
      items.push('Cancelar')
    }
    if (row.status === 'Cancelado') {
      items.push('Info Cancelamento')
    }
    return items
  }

  const onMenuItemClicked = (item, row) => {
    if (item === 'Ver Resultado') {
      if (row.status === 'Em Andamento') {
        dispatch(showMessageBox(null, 'Não é possível ver o resultado de uma conferência Em Andamento'))
        return
      }
      history.push('/main/picking/reconferencia-etiqueta/resultado', {
        conferencia_id: row.id,
      })
    } else if (item === 'Cancelar') {
      if (row.status === 'Finalizado') {
        dispatch(showMessageBox(null, 'Não é possível cancelar uma conferência já finalizada'))
        return
      }
      setSelectedConferencia(row)
      setCancelReason('')
      setShowCancelModal(true)
    } else if (item === 'Info Cancelamento') {
      setCanceledInfo(row)
      setShowCanceledInfoModal(true)
    }
  }

  const handleCancelar = async () => {
    if (!cancelReason.trim()) {
      dispatch(showMessageBox(null, 'Informe a justificativa'))
      return
    }
    try {
      dispatch(showLoadingBox('Aguarde', 'Cancelando conferência...'))
      const { id: user_id } = getUsuarioInfo()
      await postReconferenciaEtiquetaCancelar(selectedConferencia.id, user_id, cancelReason.trim(), selectedTp)
      setShowCancelModal(false)
      buscar()
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  return (
    <div>
      <PageHeader>4.9 - Re-conferência - Etiqueta</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid" style={{ marginBottom: 20 }}>
            <div className="p-col-4">
              <Periodo
                btnEnabled={!!selectedTp}
                periodoInicial={periodo.dataInicial}
                periodoFinal={periodo.dataFinal}
                onPesquisar={buscar}
                onChangePeriodoInicial={val => setPeriodo(p => ({ ...p, dataInicial: val }))}
                onChangePeriodoFinal={val => setPeriodo(p => ({ ...p, dataFinal: val }))}
              />
            </div>
          </div>

          <DataTable
            header={<CustomDataTableHeader onChange={setGlobalFilter} />}
            globalFilter={globalFilter}
            value={data}
            emptyMessage="Nenhuma conferência encontrada para o período selecionado"
            paginator
            rows={15}
            loading={isLoading}
          >
            <Column field="id" header="Código" style={tableCellCentered(80)} sortable />
            <Column field="pallet_area_id" header="Pallet" style={tableCellCentered(80)} sortable />
            <Column field="empresa_nome" header="Empresa" style={tableCellCentered(200)} sortable />
            <Column
              field="conferido_por"
              header="Conferido Por"
              style={tableCellCentered(180)}
              sortable
            />
            <Column
              field="status"
              header="Status"
              style={tableCellCentered(140)}
              body={row => (
                <Badge color={STATUS_COLORS[row.status] || '#999'}>{row.status}</Badge>
              )}
              sortable
            />
            <Column
              header="Menu"
              style={tableCellCentered(70)}
              body={row => (
                <ThreeDots
                  items={getMenuItems(row)}
                  onClick={item => onMenuItemClicked(item, row)}
                />
              )}
            />
          </DataTable>
        </CustomPanel>
      </div>

      {/* Modal Cancelar */}
      <div className="ConfirmDialog">
        <Dialog
          header="Cancelar Conferência"
          visible={showCancelModal}
          modal={true}
          style={{ width: '450px' }}
          onHide={() => setShowCancelModal(false)}
          footer={
            <div>
              <Btn onClick={handleCancelar}>Salvar</Btn>
            </div>
          }
        >
          <CustomInputTextArea
            label="Justificativa"
            value={cancelReason}
            onChange={val => setCancelReason(val)}
            rows={5}
          />
        </Dialog>
      </div>

      {/* Modal Info Cancelamento */}
      <div className="ConfirmDialog">
        <Dialog
          header="Informações de Cancelamento"
          visible={showCanceledInfoModal}
          modal={true}
          style={{ width: '450px' }}
          onHide={() => setShowCanceledInfoModal(false)}
        >
          {canceledInfo && (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                <div style={{ flex: 1 }}><strong>Cancelado por</strong></div>
                <div style={{ width: 250 }}>{canceledInfo.cancelado_por}</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                <div style={{ flex: 1 }}><strong>Data</strong></div>
                <div style={{ width: 250 }}>
                  {canceledInfo.canceled_at
                    ? formatIsoDateToLocale(canceledInfo.canceled_at).toFormat('dd/MM/yyyy HH:mm:ss')
                    : '-'}
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 8 }}>
                <div style={{ flex: 1 }}><strong>Motivo</strong></div>
                <div style={{ width: 250 }}>{canceledInfo.canceled_reason}</div>
              </div>
            </div>
          )}
        </Dialog>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ReconferenciaEtiqueta))
